export default __webpack_public_path__ + "static/media/Rectangle 367.c3db5115.png";